export { default } from './WardrobeItemDescription'
